// src/components/Featured.jsx
import React from "react";

const MAROON = "#800020";

export default function Featured({ items = [] }) {
  return (
    <section className="w-full max-w-5xl mx-auto px-4 md:px-0 mt-6 mb-10 space-y-6">
      {items.map((it, i) => (
        <article
          key={`${it.title}-${i}`}
          className="flex flex-col md:flex-row items-start gap-4 md:gap-6"
        >
          {/* Fixed-size image box so text never wraps underneath */}
          <div
            className="rounded-2xl overflow-hidden border flex-shrink-0
                       w-44 h-28 sm:w-56 sm:h-36 md:w-64 md:h-40"
            style={{ borderColor: MAROON }}
          >
            <img
              src={it.image}
              alt={`${it.title} — ${it.org}`}
              className="w-full h-full object-cover block"
            />
          </div>

          {/* Text side; min-w-0 prevents flex wrapping glitches */}
          <div className="min-w-0">
            <h2
              className="text-xl md:text-2xl font-semibold leading-snug"
              style={{ color: MAROON }}
            >
              {it.title}
            </h2>
            <p className="text-sm md:text-base opacity-90 mb-2" style={{ color: MAROON }}>
              {it.org}
            </p>

            {it.review && (it.review.quote || it.review.source) && (
              <p className="text-sm md:text-base" style={{ color: MAROON }}>
                <span className="opacity-80">Review: </span>
                {it.review.source ? (
                  <strong>{it.review.source}</strong>
                ) : null}
                {it.review.quote ? (
                  <>
                    {" "}
                    —{" "}
                    <a
                      href={it.review.quote}
                      target="_blank"
                      rel="noreferrer"
                      className="underline underline-offset-2 hover:opacity-80 break-words"
                    >
                      Read the piece
                    </a>
                  </>
                ) : null}
              </p>
            )}
          </div>
        </article>
      ))}
    </section>
  );
}
